import { Dimensions } from 'react-native'

import { i18n } from '@localization'
import { BTN, Stack, colors as zetColors } from '@zet/design-system'
import CreditCardFilled from '@zet/design-system/svg/CreditCardFilled'
import CreditCardOutlined from '@zet/design-system/svg/CreditCardOutlined'
import MoneyBagFilled from '@zet/design-system/svg/MoneyBagFilled'
import MoneyBagOutlined from '@zet/design-system/svg/MoneyBagOutlined'
import MoreFilled from '@zet/design-system/svg/MoreFilled'
import MoreOutlined from '@zet/design-system/svg/MoreOutlined'
import QuestionMarkOutlined from '@zet/design-system/svg/QuestionMarkOutlined'
import WiredEarPhones from '@zet/feature-loyalty/assets/svg/wiredEarphones.svg'
import PriceStar from '@zet/svg/assets/PriceStar.svg'
import AnnounceOutlined from '@zet/svg/assets/announcementOutlined.svg'
import CalendarDayOutlined from '@zet/svg/assets/calendarDayOutlined.svg'
import GiftOutlined from '@zet/svg/assets/giftOutlined.svg'
import BlueGiftBox from '@zet/svg/blueGiftBox'
import BronzeFrame from '@zet/svg/bronzeFrame.svg'
import BronzePodium from '@zet/svg/bronzePodium.svg'
import BronzePodiumWithNumber from '@zet/svg/bronzePodiumWithNumber.svg'
import DeliveryBox from '@zet/svg/deliveryBox'
import DigitalSilver from '@zet/svg/digitalSilver'
import DoneOutlined from '@zet/svg/doneOutlined.svg'
import EarPhones from '@zet/svg/earphones'
import Gold from '@zet/svg/gold'
import GoldFrame from '@zet/svg/goldFrame.svg'
import GoldPodium from '@zet/svg/goldPodium.svg'
import GoldPodiumWithNumber from '@zet/svg/goldPodiumWithNumber.svg'
import LockIcon from '@zet/svg/lock.svg'
import Money from '@zet/svg/money'
import PodiumFilled from '@zet/svg/podiumFilled.svg'
import ShoppingBag from '@zet/svg/shoppingBag'
import SilverFrame from '@zet/svg/silverFrame.svg'
import SilverPodium from '@zet/svg/silverPodium.svg'
import SilverPodiumWithNumber from '@zet/svg/silverPodiumWithNumber.svg'
import SmartWatch from '@zet/svg/smartWatch'
import SuccessTick from '@zet/svg/successTick.svg'
import { ContestCardTypes } from '@zet/utils/Constants'

import Tick from '../../assets/svgs/tick.svg'
import { IContestData } from '../api/contest/types'

export const DEVICE_WIDTH = Dimensions.get('window').width
export const DEVICE_HEIGHT = Dimensions.get('window').height

export const enum LeadStatus {
  LEAD_ADDED = 'leadadded',
  ACTION_REQUIRED = 'actnreqrd',
  PARTIALLY_FULLFILLED = 'pfulfilled',
  FULLFILLED = 'fullfilled',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  INCOMPLETE = 'saleIncomplete',
}

export const enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  REJECTED = 'rejected',
  FAILED = 'failed',
}

export const QuickFilter = {
  stage: {
    name: 'stage',
    value: [],
  },
  brands: {
    name: 'partner',
    value: [] as string[],
  },
  profileStatus: {
    name: 'status',
    value: [] as string[],
  },
  category: {
    name: 'category',
    value: [] as string[],
  },
}

export const playstoreRedirection =
  'https://play.google.com/store/apps/details?id=in.onecode.app'

export const appstoreRedirection =
  'https://apps.apple.com/in/app/zet-partner-earn-extra-income/id6753862458'

export const appVideos = {
  zetMyNetwork: {
    title: ' ',
    videoId: '0lIu6rbrzgI',
  },
  zetMyTeam: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetMyCustomers: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetWhyPan: {
    title: ' ',
    videoId: 'Q5PmwtJLUrs',
  },
  zetWhyOtp: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetHowToEarn: {
    title: ' ',
    videoId: 'kcvKVPUyrEY',
  },
  zetPlaceHolder: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetCreditScore: {
    title: ' ',
    videoId: 'uCq0WNrsjI8',
  },
}

export const Months = [
  {
    label: 'January',
    key: 0,
    value: 'january',
  },
  {
    label: 'February',
    key: 1,
    value: 'february',
  },
  {
    label: 'March',
    key: 2,
    value: 'march',
  },
  {
    label: 'April',
    key: 3,
    value: 'april',
  },
  {
    label: 'May',
    key: 4,
    value: 'may',
  },
  {
    label: 'June',
    key: 5,
    value: 'june',
  },
  {
    label: 'July',
    key: 6,
    value: 'july',
  },
  {
    label: 'August',
    key: 7,
    value: 'august',
  },
  {
    label: 'September',
    key: 8,
    value: 'september',
  },
  {
    label: 'October',
    key: 9,
    value: 'october',
  },
  {
    label: 'November',
    key: 10,
    value: 'november',
  },
  {
    label: 'December',
    key: 11,
    value: 'december',
  },
]
export const rejectionPayoutCategoryList = ['9', '15', '10', '11', 'all']

export const loansCategoriesEmiCalculator = ['11', '9', '10', '12']

export const filterData = [
  {
    icon: '',
    text: 'ZET Id',
    key: 'ZET_ID',
  },
  {
    icon: '',
    text: 'Phone Number',
    key: 'PHONE_NUMBER',
  },
  {
    icon: '',
    text: 'Name',
    key: 'NAME',
  },
]
export const networkFilters = [
  { icon: '', text: 'All', key: -1 },
  { icon: '', text: '0 Sale', key: 0 },
  { icon: '', text: '1 Sale', key: 1 },
  { icon: '', text: '2 Sales', key: 2 },
]
export const sortingOptionsForVerified = [
  {
    label: i18n.t('myCustomers.byCreditScore'),
    value: 'creditReport',
  },
  {
    label: i18n.t('myCustomers.byName'),
    value: 'name',
  },
  {
    label: i18n.t('myCustomers.byAdditonDate'),
    value: 'createdAt',
  },
]

export const sortingOptionsForNonVerified = [
  {
    label: i18n.t('myCustomers.byAdditonDate'),
    value: 'createdAt',
  },
  {
    label: i18n.t('myCustomers.byName'),
    value: 'name',
  },
]

export const bannerLogic = {
  COLLAPSIBLE_ON_CLICK: 'COLLAPSIBLE_ON_CLICK',
}

export const zetSalesBenefits = [
  {
    icon: <Money />,
    title: i18n.t('geniusProgram.15HigherPayout'),
  },
  {
    icon: <BlueGiftBox />,
    title: i18n.t('geniusProgram.excitingGifts'),
  },
  {
    icon: <ShoppingBag />,
    title: i18n.t('geniusProgram.offers'),
  },
]
export const enum HDFC_ASKCODES {
  $ARN_REQUIRED = '$ARN_REQUIRED',
  $ARN_PENDING = '$ARN_PENDING',
  $ARN_INCORRECT = '$ARN_INCORRECT',
}

export const enum HelpAndSupportType {
  RAISE_A_COMPAINT = 'raiseAComplaint',
  CHAT_WITH_US = 'chatWithUs',
  CALL_US = 'callUs',
  FAQS = 'faqs',
}

export const enum AgentTiers {
  BEGINNER = 'Beginner',
  PRO = 'Pro',
  GENIUS = 'Genius',
  EXPERT = 'Expert',
}

export const enum TiersWarningDays {
  'Beginner' = 7,
  'Pro' = 7,
  'Genius' = 7,
  'Expert' = 7,
}

export const WarningDays = 7

export const BEGINNER = 'BEGINNER'
export const PRO = 'PRO'
export const GENIUS = 'GENIUS'
export const EXPERT = 'EXPERT'
export const enum TierStatus {
  SKIPPED = 'Skipped',
  ACHIEVED = 'Achieved',
  AVAILABLE = 'Available',
}

export const zetCoinsOnCustomerAddition = [
  {
    type: i18n.t('loyaltyDetails.beginner'),
    points: i18n.t('loyaltyDetails.2zc'),
    borderColor: zetColors.grays[40],
  },
  {
    type: i18n.t('loyaltyDetails.pro'),
    points: i18n.t('loyaltyDetails.3zc'),
    borderColor: zetColors.primary[30],
  },
  {
    type: i18n.t('loyaltyDetails.expert'),
    points: i18n.t('loyaltyDetails.6zc'),
    borderColor: zetColors.warning[10],
  },
  {
    type: i18n.t('loyaltyDetails.genius'),
    points: i18n.t('loyaltyDetails.10zc'),
    borderColor: zetColors.success[30],
  },
]

export const filters = [
  {
    creditCard: {
      name: i18n.t('loyaltyDetails.creditCard'),
      icon: {
        selected: <CreditCardOutlined />,
        notSelected: <CreditCardFilled color={zetColors.neutral.white100} />,
      },
      points: [
        {
          type: i18n.t('loyaltyDetails.beginner'),
          points: i18n.t('loyaltyDetails.500zc'),
          borderColor: zetColors.grays[40],
        },
        {
          type: i18n.t('loyaltyDetails.pro'),
          points: i18n.t('loyaltyDetails.750zc'),
          borderColor: zetColors.primary[30],
        },
        {
          type: i18n.t('loyaltyDetails.expert'),
          points: i18n.t('loyaltyDetails.1000zc'),
          borderColor: zetColors.warning[10],
        },
        {
          type: i18n.t('loyaltyDetails.genius'),
          points: i18n.t('loyaltyDetails.2000zc'),
          borderColor: zetColors.success[30],
        },
      ],
    },
  },
  {
    loan: {
      name: i18n.t('loyaltyDetails.loan'),
      icon: {
        selected: <MoneyBagOutlined />,
        notSelected: <MoneyBagFilled color={zetColors.neutral.white100} />,
      },
      points: [
        {
          type: i18n.t('loyaltyDetails.beginner'),
          points: i18n.t('loyaltyDetails.200zc'),
          borderColor: zetColors.grays[40],
        },
        {
          type: i18n.t('loyaltyDetails.pro'),
          points: i18n.t('loyaltyDetails.300zc'),
          borderColor: zetColors.primary[30],
        },
        {
          type: i18n.t('loyaltyDetails.expert'),
          points: i18n.t('loyaltyDetails.600zc'),
          borderColor: zetColors.warning[10],
        },
        {
          type: i18n.t('loyaltyDetails.genius'),
          points: i18n.t('loyaltyDetails.1000zc'),
          borderColor: zetColors.success[30],
        },
      ],
    },
  },

  // {
  //   magnet: {
  //     name: 'Magnet',
  //     icon: {
  //       selected: <MagnetOutlined />,
  //       notSelected: <MagnetFilled />,
  //     },
  //     points: [
  //       {
  //         type: i18n.t('loyaltyDetails.beginner'),
  //         points: i18n.t('loyaltyDetails.150zc'),
  //         borderColor: zetColors.grays[40],
  //       },
  //       {
  //         type: i18n.t('loyaltyDetails.pro'),
  //         points: i18n.t('loyaltyDetails.300zc'),
  //         borderColor: zetColors.primary[30],
  //       },
  //       {
  //         type: i18n.t('loyaltyDetails.expert'),
  //         points: i18n.t('loyaltyDetails.700zc'),
  //         borderColor: zetColors.warning[10],
  //       },
  //       {
  //         type: i18n.t('loyaltyDetails.genius'),
  //         points: i18n.t('loyaltyDetails.1000zc'),
  //         borderColor: zetColors.success[30],
  //       },
  //     ],
  //   },
  // },
  // {
  //   instantLoans: {
  //     name: 'Instant Loan',
  //     icon: {
  //       selected: <MoneyBagOutlined />,
  //       notSelected: <MoneyBagFilled color={zetColors.neutral.white100} />,
  //     },
  //     points: [
  //       {
  //         type: i18n.t('loyaltyDetails.beginner'),
  //         points: i18n.t('loyaltyDetails.50zc'),
  //         borderColor: zetColors.grays[40],
  //       },
  //       {
  //         type: i18n.t('loyaltyDetails.pro'),
  //         points: i18n.t('loyaltyDetails.100zc'),
  //         borderColor: zetColors.primary[30],
  //       },
  //       {
  //         type: i18n.t('loyaltyDetails.expert'),
  //         points: i18n.t('loyaltyDetails.200zc'),
  //         borderColor: zetColors.warning[10],
  //       },
  //       {
  //         type: i18n.t('loyaltyDetails.genius'),
  //         points: i18n.t('loyaltyDetails.400zc'),
  //         borderColor: zetColors.success[30],
  //       },
  //     ],
  //   },
  // },
  {
    otherCategories: {
      name: i18n.t('loyaltyDetails.otherCategories'),
      icon: {
        selected: <MoreOutlined />,
        notSelected: <MoreFilled color={zetColors.neutral.white100} />,
      },
      points: [
        {
          type: i18n.t('loyaltyDetails.beginner'),
          points: i18n.t('loyaltyDetails.10zc'),
          borderColor: zetColors.grays[40],
        },
        {
          type: i18n.t('loyaltyDetails.pro'),
          points: i18n.t('loyaltyDetails.20zc'),
          borderColor: zetColors.primary[30],
        },
        {
          type: i18n.t('loyaltyDetails.expert'),
          points: i18n.t('loyaltyDetails.30zc'),
          borderColor: zetColors.warning[10],
        },
        {
          type: i18n.t('loyaltyDetails.genius'),
          points: i18n.t('loyaltyDetails.40zc'),
          borderColor: zetColors.success[30],
        },
      ],
    },
  },
]
export const enum ZetGifts {
  'ONBOARDING_KIT' = 'Tshirt',
  'AUGMONT_SILVER' = 'Silver',
  'EAR_PHONES' = 'Earphones',
  'SMART_WATCH' = 'Smartwatch',
  'WIRED_EARPHONES' = 'WiredEarphones',
  'WIRELESS_EARPHONES' = 'WirelessEarphones',
}

export const enum GiftStatus {
  'ADDRESS_EDITABLE' = 'edit_address',
  'PACKING' = 'packing',
  'IN_TRANSIT' = 'in_transit',
  'DELIVERED' = 'delivered',
  'FAILED' = 'failed',
  'AVAILABLE_TO_CLAIM' = 'available_to_claim',
  'DELAYED' = 'delayed',
  'CLAIMED' = 'claimed',
  'COMING_SOON' = 'coming_soon',
  'VIEW_REWARDS' = 'view_rewards',
}

export const GiftStatusText = {
  edit_address: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.editAddress')}
    </BTN>
  ),
  packing: (
    <Stack className="bg-grays-30 rounded-xl px-2">
      <BTN className="text-grays-70">{i18n.t('loyaltyDetails.packing')}</BTN>
    </Stack>
  ),
  in_transit: (
    <Stack className="bg-grays-30 rounded-xl px-2">
      <BTN className="text-warning-100">
        {i18n.t('loyaltyDetails.inTransit')}
      </BTN>
    </Stack>
  ),
  delivered: (
    <Stack className="bg-success-10 rounded-xl px-2">
      <BTN className="text-success-100">
        {i18n.t('loyaltyDetails.delivered')}
      </BTN>
    </Stack>
  ),
  available_to_claim: (
    <BTN className="text-primary-100">{i18n.t('loyaltyDetails.claim')}</BTN>
  ),
  claimed: (
    <Stack className="bg-success-10 rounded-xl px-2">
      <BTN className="text-success-100">{i18n.t('loyaltyDetails.claimed')}</BTN>
    </Stack>
  ),
  coming_soon: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.comingSoon')}
    </BTN>
  ),
  view_rewards: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.viewRewards')}
    </BTN>
  ),
  failed: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.unsuccessful')}
    </BTN>
  ),
  available_to_claim_aug: (
    <Stack className="bg-grays-30 rounded-xl px-2">
      <BTN className="text-grays-70">{i18n.t('loyaltyDetails.processing')}</BTN>
    </Stack>
  ),
  view_rewards_aug: (
    <Stack className="bg-success-10 rounded-xl px-2">
      <BTN className="text-success-100">
        {i18n.t('loyaltyDetails.processed')}
      </BTN>
    </Stack>
  ),
}

export const giftObject = {
  Earphones: {
    heading: i18n.t('loyaltyDetails.earphones'),
    subHeading: i18n.t('loyaltyDetails.earphonesSubHeading'),
    icon: <Gold />,
  },
  Tshirt: {
    heading: i18n.t('loyaltyDetails.zetOnboardingKit'),
    subHeading: i18n.t('loyaltyDetails.zetOnboardingKitSubHeading'),
    icon: <DeliveryBox />,
  },
  Silver: {
    heading: i18n.t('loyaltyDetails.silver'),
    subHeading: i18n.t('loyaltyDetails.earnSilver'),
    icon: <DigitalSilver />,
  },
  Smartwatch: {
    heading: i18n.t('loyaltyDetails.smartWatch'),
    subHeading: i18n.t('loyaltyDetails.smartWatchSubHeading'),
    icon: <SmartWatch />,
  },
  WiredEarphones: {
    heading: i18n.t('loyaltyDetails.earphones'),
    subHeading: i18n.t('loyaltyDetails.smartWatchSubHeading'),
    icon: <WiredEarPhones />,
  },
  WirelessEarphones: {
    heading: i18n.t('loyaltyDetails.premiumEarphones'),
    subHeading: i18n.t('loyaltyDetails.wirelessEarphonesSubHeading'),
    icon: <EarPhones />,
  },
}

export const initialState = [
  {
    title: i18n.t('loyaltyDetails.beginner'),
    isActive: false,
    isDone: false,
  },
  { title: i18n.t('loyaltyDetails.pro'), isActive: false, isDone: false },
  { title: i18n.t('loyaltyDetails.expert'), isActive: false, isDone: false },
  { title: i18n.t('loyaltyDetails.genius'), isActive: false, isDone: false },
]

export const levelIndexes = {
  Beginner: 0,
  Pro: 1,
  Expert: 2,
  Genius: 3,
}

export const TierTotalSales = {
  Beginner: 0,
  Pro: 2,
  Expert: 5,
  Genius: 11,
}

export const loyaltyFaqVideos = {
  becomeGenuis: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/becomeGenuis.jpg',
    videoId: 'cry3VRqDsWw',
  },
  higherPayout: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/higherPayout.jpg',
    videoId: 'cry3VRqDsWw',
  },
  zetCoins: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/zetCoins.jpg',
    videoId: 'cry3VRqDsWw',
  },
  rewardsAndCoins: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/rewardsAndCoins.jpg',
    videoId: 'cry3VRqDsWw',
  },
  beginner: {
    banner: '',
    videoId: 'xYuuseIooa8',
  },
  pro: {
    banner: '',
    videoId: '3xtKLtqqiQY',
  },
  expert: {
    banner: '',
    videoId: '8ZrkhYH2J4Q',
  },
  genius: {
    banner: '',
    videoId: '0BkMmCFiVw8',
  },
}
export const DYNAMIC_REJECTION_PAYOUT = 'upto ₹100'

export const REJECTION_PAYOUT = '₹25'

export const URL_PATH = [
  '/customer/check-credit-score',
  '/customer/login',
  '/customer/otpVerify',
]

export const enum AndroidUpdateType {
  FLEXIBLE = 0,
  IMMEDIATE = 1,
}

export enum AndroidAvailabilityStatus {
  UNKNOWN = 0,
  AVAILABLE = 2,
  UNAVAILABLE = 1,
  DEVELOPER_TRIGGERED = 3,
}
export const flotingButtonChildText = ['Card', 'Loan', 'BNPL', 'More']

export const networkStages = [
  {
    noOfSales: i18n.t('networkStages.firstSale'),
    yourEarnings: i18n.t('networkStages.rs100'),
  },
  {
    noOfSales: i18n.t('networkStages.secondSale'),
    yourEarnings: i18n.t('networkStages.rs500'),
  },
  {
    noOfSales: i18n.t('networkStages.thirdSale'),
    yourEarnings: i18n.t('networkStages.5perCent'),
  },
]

export const earningsFaqs = [
  {
    question: i18n.t('earningsFaqs.question1'),
    answer: [i18n.t('earningsFaqs.answer1')],
  },
  {
    question: i18n.t('earningsFaqs.question2'),
    answer: [i18n.t('earningsFaqs.answer2WithFee')],
  },
  {
    question: i18n.t('earningsFaqs.question3'),
    answer: [i18n.t('earningsFaqs.answer3')],
  },
  {
    question: i18n.t('earningsFaqs.question4'),
    answer: [i18n.t('earningsFaqs.answer4')],
  },
  {
    question: i18n.t('earningsFaqs.question5'),
    answer: [i18n.t('earningsFaqs.answer5')],
  },
]

export const earningsFaqsWithPlatformFee = [
  {
    question: i18n.t('earningsFaqs.question1'),
    answer: [i18n.t('earningsFaqs.answer1')],
  },
  {
    question: i18n.t('earningsFaqs.question2'),
    answer: [i18n.t('earningsFaqs.answer2')],
  },
  {
    question: i18n.t('earningsFaqs.question3'),
    answer: [i18n.t('earningsFaqs.answer3')],
  },
  {
    question: i18n.t('earningsFaqs.question4'),
    answer: [i18n.t('earningsFaqs.answer4')],
  },
  {
    question: i18n.t('earningsFaqs.question5'),
    answer: [i18n.t('earningsFaqs.answer5')],
  },
]

export const visitingCardStates = [
  'SHOW_VISITING_CARD_SCREEN',
  'SHOW_VISITING_CARD_SCREEN_V2',
  'SHOW_VISITING_CARD_SCREEN_V3',
]

export const navigateNextScreenStates = [
  'SHOW_ONBOARDING_KIT_SCREEN',
  'SHOW_VISITING_CARD_SCREEN_V2',
  'SHOW_VISITING_CARD_SCREEN_V3',
  'SHOW_ZET_ID_SCREEN_V2',
]

type PodiumType = {
  frame: JSX.Element
  podium: JSX.Element
}

export const leaderBoardPodiumTypes: Record<string, PodiumType> = {
  bronze: {
    frame: <BronzeFrame />,
    podium: <BronzePodium />,
  },
  silver: {
    frame: <SilverFrame />,
    podium: <SilverPodium />,
  },
  gold: {
    frame: <GoldFrame />,
    podium: <GoldPodium />,
  },
}

export const bharatLoansleaderBoardPodiumTypes: Record<string, PodiumType> = {
  bronze: {
    frame: <BronzeFrame />,
    podium: <BronzePodiumWithNumber />,
  },
  silver: {
    frame: <SilverFrame />,
    podium: <SilverPodiumWithNumber />,
  },
  gold: {
    frame: <GoldFrame />,
    podium: <GoldPodiumWithNumber />,
  },
}

export const getContestCardDetails = (
  data: IContestData,
  type: ContestCardTypes,
) => {
  switch (type) {
    case ContestCardTypes.DURATION_DETAILS:
      return {
        title: data?.title,
        subTitle: data?.subtitle,
        icon: data?.icon,
      }
    case ContestCardTypes.PARTICIPATE_DETAILS:
      return {
        title: data?.participateTitle,
        icon: data?.participateIcon,
        subTitle: data?.participateSubtitle,
      }
    case ContestCardTypes.FAQS:
      return {
        title: 'Frequently Asked Questions',
        icon: 'QuestionMarkOutlined',
      }
    case ContestCardTypes.PRIZE_DETAILS:
      return {
        title: data?.prizesTitle,
        icon: data?.prizesIcon,
      }
    case ContestCardTypes.EARNPOINTS:
      return {
        title: data?.prizesTitle,
        icon: data?.prizesIcon,
      }
  }
}

export const getContestCardIcon = (icon: string, color: string) => {
  switch (icon) {
    case 'AnnouncementOutlined':
      return <AnnounceOutlined color={color} />
    case 'CalenderDayOutlined':
      return <CalendarDayOutlined color={color} />
    case 'GiftOutlined':
      return <GiftOutlined color={color} />
    case 'QuestionMarkOutlined':
      return <QuestionMarkOutlined color={color} />
    case 'Tick':
      return <Tick />
    case 'PrizesStar':
      return <PriceStar color={color} />
    case 'LockIcon':
      return <LockIcon />
    case 'SuccessTick':
      return <SuccessTick />
    case 'PodiumFilled':
      return <PodiumFilled color={color} width={25} height={25} />
    case 'DoneOutined':
      return <DoneOutlined />
  }
}

export const getOrdinal = (n: number) => {
  let ord = 'th'

  if (n % 10 === 1 && n % 100 !== 11) {
    ord = 'st'
  } else if (n % 10 === 2 && n % 100 !== 12) {
    ord = 'nd'
  } else if (n % 10 === 3 && n % 100 !== 13) {
    ord = 'rd'
  }

  return ord
}

export { checkCameraPermissions } from './checkCameraPermissions'

export const SPLASH_LOAD_TIME_TRACK_LAST_DATE = new Date(
  '2024-03-15 23:59',
).getTime()

export const customerAdditionBrandLogos = [
  {
    image: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/HDFCBank.webp',
    name: 'HDFC Bank',
  },
  {
    image: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/SBIBank.webp',
    name: 'SBI Banks',
  },
  {
    image: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/IndusBank.webp',
    name: 'IndusInd Bank',
  },
  {
    image:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/BankOfBaroda.webp',
    name: 'Bank Of Baroda Bank',
  },
  {
    image:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/AmericanExpress.webp',
    name: 'HDFC Bank',
  },
  {
    image:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/AuFinanceBank.webp',
    name: 'AuFinance Bank',
  },
  {
    image: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/IdfcBank.webp',
    name: 'Idfc Bank',
  },
  {
    image: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/IIFL.webp',
    name: 'IIFL',
  },
  {
    image: 'https://onecode-asset.s3.ap-south-1.amazonaws.com/KotakBank.webp',
    name: 'Kotak Bank',
  },
]

export const bharatLoansMahotsavTeaserImages = {
  background:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Bharat+Loans+Mahotsav/Teaser+Landing+page+(1).png',
  rewardImage:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Bharat+Loans+Mahotsav/content+(5).png',
  comingSoonImg:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/Bharat+Loans+Mahotsav/Button.png',
}

export const iplCampaignVirtualImage =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/SPL/Wicket+Earnings.png'

export const iplLeaderboardTopImages = [
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/SPL/Leader+Board+Top.png',
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/SPL/Title+(1).png',
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/ZET_Partner/SPL/Instant+Payout.png',
]

export const widgetFlowUrls = ['/motor/insurance']
